<script>
  import { Chart } from 'flowbite-svelte';
  import { stringify } from 'csv-stringify/browser/esm/sync';
  import Legend from './Legend.svelte';
  import { formatNumberWithIntl } from './utils';

  export let options;
  export let chartData;
  export let legend;
  export let startDate;
  export let endDate;
  export let sendReportCsvExportDebugEvent;

  const COLORS = ['#1C64F2', '#16BDCA', '#FDBA8C', '#E74694'];
  const INDICATOR_BGS = [
    'bg-[#1C64F2]',
    'bg-[#16BDCA]',
    'bg-[#FDBA8C]',
    'bg-[#E74694]',
  ];

  $: options = {
    labels: chartData?.labels,
    series: chartData?.series,
    dataLabels: {
      enabled: false,
    },
    colors: COLORS,
    chart: {
      width: '100%',
      height: 222,
      type: 'donut',
    },
    stroke: {
      colors: ['transparent'],
      lineCap: '',
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              show: true,
              fontFamily: 'Inter, sans-serif',
              offsetY: 20,
            },
            total: {
              showAlways: true,
              show: true,
              label: 'Mobile Clicks',
              fontFamily: 'Inter, sans-serif',
              color: '#6B7280',
              formatter(w) {
                const sum = w.globals.seriesTotals.reduce((a, b) => {
                  return a + b;
                }, 0);
                return formatNumberWithIntl(sum);
              },
            },
            value: {
              show: true,
              fontFamily: 'Inter, sans-serif',
              fontSize: '30px',
              fontWeight: 700,
              offsetY: -20,
            },
          },
          size: '80%',
        },
      },
    },
    grid: {
      padding: {
        top: -2,
      },
    },
    legend: {
      show: false,
    },
    yaxis: {
      labels: {
        formatter(value) {
          return formatNumberWithIntl(value);
        },
      },
    },
    xaxis: {
      labels: {
        formatter(value) {
          return formatNumberWithIntl(value);
        },
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
    },
  };

  function handleClickExport() {
    const mappedResults = Object.entries(
      chartData?.currentJourneysByKey || {},
    ).map((e) => {
      const [key, value] = e;
      return {
        referrer: key,
        mobile_clicks: value.mobile_journeys,
      };
    });

    mappedResults.sort((a, b) => b.mobile_clicks - a.mobile_clicks);

    const csv = stringify(mappedResults, {
      header: true,
      columns: [{ key: 'referrer' }, { key: 'mobile_clicks' }],
    });

    sendReportCsvExportDebugEvent('referral');

    // Generate a hidden element to trigger file download
    const hiddenElement = window.document.createElement('a');
    hiddenElement.href = `data:text/csv;charset=utf-8,${encodeURI(csv)}`;
    hiddenElement.target = '_blank';
    hiddenElement.download = `clicks_by_referrer_${startDate}_${endDate}.csv`;
    hiddenElement.click();
  }
</script>

<Chart {options} class="py-6" />
<Legend
  onClickExport={handleClickExport}
  indicatorColors={INDICATOR_BGS}
  {legend}
  key="social_platform"
/>
